import { useContext } from 'react';

import { Icons } from '@/assets/icons/icons';
import { FeedCompactRow } from '@/features/action-cards-view/feed/FeedCompactRow';
import { FeedDensityContext } from '@/features/action-cards-view/feed/feedDensity';
import { FeedRow } from '@/features/action-cards-view/feed/FeedRow';
import type { FeedRowView } from '@/features/action-cards-view/feed/feedRowView';

import type { FeedChatView } from '../use-feed-chats';

const rowViewFor = (chat: FeedChatView): FeedRowView => ({
  title: chat.title,
  verb: null,
  age: chat.ageAt,
  stake: null,
  pill: null,
  running: chat.status === 'working',
  failed: chat.status === 'failed',
  outcome: null,
  openUrl: null,
});

const labelFor = (status: FeedChatView['status']) => {
  if (status === 'working') return 'Working…';
  if (status === 'failed') return 'Failed';
  if (status === 'stopped') return 'Stopped';
  return 'Reply ready';
};

export const FeedChatRow = ({
  chat,
  onOpen,
  onDismiss,
}: {
  chat: FeedChatView;
  onOpen: () => void;
  onDismiss?: () => void;
}) => {
  const density = useContext(FeedDensityContext);
  const rowProps = {
    view: rowViewFor(chat),
    icon: (
      <span className="flex size-[var(--ac-row-tile)] shrink-0 items-center justify-center rounded-full bg-secondary text-foreground-muted">
        <Icons.chat aria-hidden="true" className="size-[var(--ac-row-glyph)]" />
      </span>
    ),
    appName: 'Littlebird',
    label: labelFor(chat.status),
    labelDot: chat.status === 'reply-ready' || chat.status === 'stopped',
    onOpen,
    onDismiss,
    onPress: () => {},
    onOpenUrl: () => {},
  };

  return density === 'compact' ? (
    <FeedCompactRow
      {...rowProps}
      labelAccessory={
        chat.snippet ? (
          <span className="min-w-0 flex-1 truncate text-[length:calc(12*var(--ac-u))] text-foreground-muted">
            {chat.snippet}
          </span>
        ) : undefined
      }
    />
  ) : (
    <FeedRow {...rowProps} description={chat.snippet || undefined} />
  );
};
